import { __assign, __rest } from "tslib";
import * as React from 'react';
import { Image, I18nManager, Platform } from 'react-native';
//import { Consumer as SettingsConsumer } from '../core/settings';
//import { accessibilityProps } from './MaterialCommunityIcon';
var isImageSource = function (source) {
  // source is an object with uri
  return typeof source === 'object' && source !== null && Object.prototype.hasOwnProperty.call(source, 'uri') && typeof source.uri === 'string' ||
  // source is a module, e.g. - require('image')
  typeof source === 'number' ||
  // image url on web
  Platform.OS === 'web' && typeof source === 'string' && (source.startsWith('data:image') || /\.(bmp|jpg|jpeg|png|gif|svg)$/.test(source));
};
var getIconId = function (source) {
  if (typeof source === 'object' && source !== null && Object.prototype.hasOwnProperty.call(source, 'uri') && typeof source.uri === 'string') {
    return source.uri;
  }
  return source;
};
export var isValidIcon = function (source) {
  return typeof source === 'string' || isImageSource(source);
};
export var isEqualIcon = function (a, b) {
  return a === b || getIconId(a) === getIconId(b);
};
var Icon = function (_a) {
  var source = _a.source,
    color = _a.color,
    size = _a.size,
    theme = _a.theme,
    rest = __rest(_a, ["source", "color", "size", "theme"]);
  var direction = typeof source === 'object' && source.direction && source.source ? source.direction === 'auto' ? I18nManager.isRTL ? 'rtl' : 'ltr' : source.direction : null;
  var s = typeof source === 'object' && source.direction && source.source ? source.source : source;
  var iconColor = color || "#003087";
  if (isImageSource(s)) {
    return /*#__PURE__*/React.createElement(Image, __assign({}, rest, {
      source: s,
      style: [{
        transform: [{
          scaleX: direction === 'rtl' ? -1 : 1
        }]
      }, {
        width: size,
        height: size,
        tintColor: color,
        resizeMode: 'contain'
      }]
    }));
  } else if (typeof s === 'string') {
    return null
    // <SettingsConsumer>
    //   {({ icon }) => {
    //     return icon({
    //       name: s,
    //       color: iconColor,
    //       size,
    //       direction,
    //     });
    //   }}
    // </SettingsConsumer>
    ;
  } else if (typeof s === 'function') {
    return s({
      color: iconColor,
      size: size,
      direction: direction
    });
  }
  return null;
};
export default Icon;